module.exports = __webpack_public_path__ + "components/weather-icon/static/daydrizzle-743322b263a6e69411cfec41444067fb.svg";